__turbopack_context__.v({
  "className": "azeret_mono_a7115f8b-module__ID7YAW__className",
  "variable": "azeret_mono_a7115f8b-module__ID7YAW__variable",
});
